import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { from, Observable } from 'rxjs';
import * as translate from "translate";
import { PasswordHelpContent } from '../../interfaces/password-help-content.interface';

@Component({
    selector: 'mono-common-password-help-popup',
    templateUrl: './password-help-popup.component.html',
})
export class PasswordHelpPopupComponent implements OnInit {

  @Input() passwordHelp: PasswordHelpContent = {
    passwordHelpReveal: "View password help",
    title: "Password help",
    passwordDescription: "Think of 3 memorable, unrelated words and add dashes:",
    passwordExample: "kettle-sunflower-road",
    dontUseExample: "(You can't use this example.)",
    selectShow: "Select 'show' to see your typing."
  }
  @Input() inputAttachedTo: ElementRef;
  @Input() helpPopupCalledFrom: string;

  @Output() helpPopupToggleEmit? = new EventEmitter<boolean>();

  public helpPopupOpen = false;
  public temporaryHelpHTML: string;

  constructor() { }

  ngOnInit(): void {
    this.temporaryHelpHTML = `<p>${this.passwordHelp.passwordDescription} </p><p class="indented">${this.passwordHelp.passwordExample}</p><p><b>${this.passwordHelp.dontUseExample}</b></p><p>${this.passwordHelp.selectShow}</p>`;
  }

  public onOpenHelpPopup() {
    this.helpPopupOpen = true;
    this.helpPopupToggleEmit.emit(true);
  }

  public onCloseHelpPopup() {
    this.helpPopupOpen = false;
    this.helpPopupToggleEmit.emit(false);
  }

  public preventFocusOnElement(event) {
    event.preventDefault();
  }

}